import { initLightbox } from './lightbox';
import { initNav, initScrollAnimations } from './nav';

initNav();
initScrollAnimations();
initLightbox('.gallery-grid .gallery-item img');
